import { render, staticRenderFns } from "./teachers-stats.vue?vue&type=template&id=3be821fa&"
import script from "./teachers-stats.vue?vue&type=script&lang=js&"
export * from "./teachers-stats.vue?vue&type=script&lang=js&"
import style0 from "./teachers-stats.vue?vue&type=style&index=0&id=3be821fa&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports